import { render, staticRenderFns } from "./transaction-benefits.vue?vue&type=template&id=5f5e1792&scoped=true"
import script from "./transaction-benefits.vue?vue&type=script&lang=js"
export * from "./transaction-benefits.vue?vue&type=script&lang=js"
import style0 from "./transaction-benefits.vue?vue&type=style&index=0&id=5f5e1792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e1792",
  null
  
)

export default component.exports